<template>
  <div class="c-white-background">
    <MainNavBarWapV2 :object-data="infoHeader" />
    <div class="container colum top-spacing">
      <h5 class="title m-0 text-uppercase c-body2 text-center">
        {{ $t("policyObj.text105") }}
      </h5>
      <div class="content mt-10">
        <p class="lh-18 fw-600 ">
          {{ $t("policyObj.text106") }}
        </p>
        <p class="lh-18 ">
          {{ $t("policyObj.text107") }}
        </p>
        <div class="ml-20">
          <p class="lh-18 m-0">• {{ $t("policyObj.text108") }}</p>

          <p class="lh-18">• {{ $t("policyObj.text109") }}</p>
        </div>

        <p class="lh-18 fw-600">
          {{ $t("policyObj.text110") }}
        </p>
        <div class="ml-20">
          <p class="lh-18 m-0">• {{ $t("policyObj.text111") }}</p>

          <p class="lh-18">• {{ $t("policyObj.text112") }}</p>
        </div>
        <p class="lh-18 fw-600 ">
          {{ $t("policyObj.text113") }}
        </p>
        <div class="ml-20">
          <p class="lh-18">• {{ $t("policyObj.text114") }}</p>
        </div>
        <p class="lh-18 fw-600 ">
          {{ $t("policyObj.text115") }}
        </p>

        <div class="ml-20">
          <p class="lh-18 ">• {{ $t("policyObj.text116") }}</p>
        </div>
        <p class="lh-18 fw-600 ">
          {{ $t("policyObj.text117") }}
        </p>
        <div class="ml-20">
          <p class="lh-18 ">• {{ $t("policyObj.text118") }}</p>
        </div>
        <p class="lh-18 fw-600 ">
          {{ $t("policyObj.text119") }}
        </p>
        <div class="ml-20">
          <p class="lh-18 m-0">• {{ $t("policyObj.text120") }}</p>
          <p class="lh-18 ">• {{ $t("policyObj.text121") }}</p>
        </div>
        <p style="font-style: italic;" class="lh-18 fw-600 ">
          {{ $t("policyObj.text122") }}
        </p>
        <div class="ml-20">
          <p class="lh-18 ">• {{ $t("policyObj.text123") }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MainNavBarWapV2 from "@/layout/WapV2/MainNavBar.vue";

export default {
  name: "police-delivery",
  computed: {},
  components: {
    MainNavBarWapV2
  },
  props: {},
  data() {
    return {
      infoHeader: {
        title: this.$t("policyObj.text104"),
        isShowHomeIcon: true,
        isShowMenu: true
      }
    };
  },
  created() {}
};
</script>
<style scoped>
.top-spacing {
  padding-top: 100px;
}
@media screen and (min-width: 0px) and (max-width: 991px) {
  .top-spacing {
    padding-top: 60px;
  }
}
</style>
